import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 18H9V16H21V18ZM21 13H3V11H21V13ZM21 8H9V6H21V8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MenuAlt02"
);
